<template>
		<div class="content home-page">
<!--		<Header></Header>-->
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png"  class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>
			<div class="info crfff">
        <div class="fs50 mt20 ac">{{$t('SubscribePackage')}}</div>
        <div class="list mt30">
          <div class="li" v-if="isShow||isShow2=='daily'" @click="getSub('daily')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('Daily')}}<br />{{$t('Subscribe')}}</strong>
            </div>
            <div class="rf">
              {{$t('DailyKyats')}}
            </div>
          </div>
          <div class="li" v-if="isShow||isShow2=='weekly'" @click="getSub('weekly')">
            <div class="lf">
              <img src="../../static/images/fen.png" />
              <strong>{{$t('Weekly')}}<br />{{$t('Subscribe')}}</strong>
            </div>
            <div class="rf">
              {{$t('WeeklyKyats')}}
            </div>
          </div>
        </div>
			</div>
		</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
    Dialog
    },
    data() {
      return {
       isShow:null,
       isShow2:'',
       mobile:'',
      }
    },
	created(){
    this.report_page();
    if(this.$route.query.type){
      this.isShow = false
      if(this.$route.query.type=='daily'){
        this.isShow2 = 'daily'
      }else{
        this.isShow2 = 'weekly'
      }
    }else{
      this.isShow = true
    }

    if(this.$route.query.mobile){
      this.mobile = this.$route.query.mobile
    }


	},
  methods: {
		back(){
			this.$router.go(-1);
      // this.$router.push({path:'/land',query: {msisdn:this.$route.query.mobile}});
		},

    getSub(type){
      let that =this;
      var channelId  = this.$route.query.channelId
      var tracker  = this.$route.query.tracker
      var code  = this.$route.query.code
      let data = {
        type:type,
        mobile:that.mobile,
        channelId:channelId,
        tracker:tracker,
        code:code,
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/sub',data,r =>{
      	that.$parent.returnCode(r,function(){
      		that.$parent.loadModal(false);
          if (r.code == 1){
            that.$parent.returnCode(r,function(){
              localStorage.setItem('token',r.data.userinfo.token)
              localStorage.setItem('mobile',r.data.userinfo.mobile)
              that.$router.push('/');
            });
          }else{
            that.$utils.alertText(r.msg,100, 3000);
          }
      	});

      })
    },
    report_page(){
      let that = this
      let mobile = this.$route.query.mobile;
      let data = {'type': 'purchase','mobile':mobile}
      that.$api.post('/api/report/process', data, r => {
        that.$parent.returnCode(r, function () {

        })
      })
    }
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/purchaseChances2.vue